import React, { useRef } from "react";
import Modal from "./Modal";

/**
 * In-App Confirmation-Dialog. Ersetzt `window.confirm()`-Popups, die vom
 * Browser gerendert werden und optisch nicht ins App-Theme passen.
 *
 * Verwendung: Parent hält `confirmState` als Objekt oder null, setzt ihn
 * wenn der User eine destruktive/bestätigungspflichtige Aktion triggert,
 * und cleart ihn im onCancel/onConfirm-Callback.
 *
 * Variants:
 *   - "default"  — blaue Primary-Confirm-Button (z.B. Save, Apply)
 *   - "danger"   — rote Error-Confirm-Button (Delete, Discard)
 */
export default function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel = "Bestätigen",
  cancelLabel = "Abbrechen",
  variant = "default",
  onConfirm,
  onCancel,
}) {
  const confirmButtonRef = useRef(null);
  const confirmClasses =
    variant === "danger"
      ? "bg-error text-on-error hover:bg-error/90"
      : "bg-primary text-on-primary hover:bg-primary/90";

  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      size="sm"
      initialFocusRef={confirmButtonRef}
    >
      {body && (
        <div className="text-sm text-on-surface-variant leading-relaxed mb-6">
          {typeof body === "string"
            ? body.split("\n").map((line, i) => <p key={i}>{line}</p>)
            : body}
        </div>
      )}
      <div className="flex items-center justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 rounded-lg text-sm font-semibold text-on-surface-variant hover:text-on-surface hover:bg-surface-container-high transition-colors"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          ref={confirmButtonRef}
          className={`px-4 py-2 rounded-lg text-sm font-semibold shadow-sm transition-colors ${confirmClasses}`}
        >
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
